<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const organization = organizationRepository.use();
  const jobs = organizationJobsRepository.useMany();

  const organizationName = computed(() => organization.value?.name ?? undefined);
</script>

<template>
  <LayoutGrid v-if="organization">
    <MpText as="h1">
      {{ organizationName }}
    </MpText>
    <WebView
      :html="organization.content"
      style="width: 100%"
    />
    <template #aside>
      <OrganizationCard />
      <OrganizationJobsCard
        v-if="jobs"
        :jobs="jobs"
      />
      <OrganizationArticles
        v-if="organization.tag"
        :tag="organization.tag"
      />
    </template>
  </LayoutGrid>
</template>
